"use client";

import { useTranslation } from "react-i18next";

import { SlotReservationContent } from "./slot-reservation-content";

import { DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog.tsx";

export default function SlotReservationModal() {
  const { t } = useTranslation("forms");

  return (
    <DialogContent
      aria-describedby={undefined}
      className="bg-background flex h-dvh max-w-5xl flex-col border-none p-0 md:h-[85vh] md:max-h-[650px]! md:rounded-lg xl:h-[75vh] xl:min-h-[min(700px_100dvh)] [&>button]:rounded-full [&>button]:border [&>button>svg]:size-5"
    >
      <DialogHeader className="h-fit px-6 pt-4">
        <DialogTitle className="text-xl font-semibold">{t("slotReservation.title")}</DialogTitle>
      </DialogHeader>
      <SlotReservationContent />
    </DialogContent>
  );
}
